// extracted by mini-css-extract-plugin
export default {"wrapper":"Video_wrapper__eCkFz","container":"Video_container__EiVEK","title":"Video_title__E6Ogt","videoContainer":"Video_videoContainer__yC6vg"};